import { render, staticRenderFns } from "./CaigouGoodsmx.vue?vue&type=template&id=fb8bb32c&scoped=true"
import script from "./CaigouGoodsmx.vue?vue&type=script&lang=js"
export * from "./CaigouGoodsmx.vue?vue&type=script&lang=js"
import style0 from "./CaigouGoodsmx.vue?vue&type=style&index=0&id=fb8bb32c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8bb32c",
  null
  
)

export default component.exports